import React, { useState } from 'react';
import './index.scss';
import { EmigrateCardTipPopover } from '../emigrateCardTipPopover';
import { classes } from '@umu/umu-util';
import { Iconfont } from '@umu/umu-design';

interface IProps {
    text: string;
    className?: string;
    popoverProps?: {
        text: string;
        img: string;
    };
}
export const EmigrateCardTip = (props: IProps) => {
    const { text, popoverProps, className } = props;
    const [show, setShow] = useState(true);
    const [hide, setHide] = useState(false);

    const onTransitionEnd = () => {
        setHide(true);
    };

    if (hide) {
        return null;
    }

    return (
        <div className={classes('emigrateCardTip', className, !show && 'hide')} onTransitionEnd={onTransitionEnd}>
            <div>
                {text}
                {popoverProps && <EmigrateCardTipPopover {...popoverProps}></EmigrateCardTipPopover>}
            </div>
            <Iconfont
                type="Close"
                onClick={() => {
                    setShow(false);
                }}
                className="close_icon"
            ></Iconfont>
        </div>
    );
};
